/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { resourceWithSyncStatusSchema } from './resourceWithSyncStatusSchema';

export const pageResponseResourceWithSyncStatusSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(resourceWithSyncStatusSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
